import {FonteDadosProxyRotaAbstract} from './fonte-dados-proxy-rota-abstract.model';
import {FonteDadosProxyParametroConfig, FonteDadosProxyParametroTipo} from './fonte-dados-proxy-parametro';

export class FonteDadosProxyRotaProcessoMetadados extends FonteDadosProxyRotaAbstract {

  rota: string;

  constructor() {
    super('recuperarProcessoMetadados', 'GET');
    this.adicionarParametroPath('origemId', 'Origem ID', 0, {
      titulo: 'Identificador do registro na fonte de dados',
      obrigatorio: true
    });
    this.criarParametrosQuery();

  }

  private criarParametrosQuery() {
    const configPadrao: FonteDadosProxyParametroConfig = {
      tipo: FonteDadosProxyParametroTipo.BOOLEAN,
      valor: true
    };
    this.adicionarParametroQuery('incluirDocumentos', 'Incluir Documentos', configPadrao);
    this.adicionarParametroQuery('incluirMovimentos', 'Incluir Movimentos', configPadrao);
    this.adicionarParametroQuery('incluirPartes', 'Incluir Partes', configPadrao);
    this.adicionarParametroQuery('incluirRelacionamentos', 'Incluir Relacionamentos', configPadrao);
  }

  limparValores() {
    super.limparValores();
    this.parametrosQuery.forEach(pq => pq.valor = true);
  }
}
